import styled from "styled-components";

export const Content = styled.div`
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const FormSection = styled.section`
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const InputContainerCourse = styled.div`
  display: flex;
  flex-direction: column;
  width: 70%;
`;

export const InputContainerYear = styled.div`
  display: flex;
  flex-direction: column;
  width: 20%;
`;

export const CourseDiv = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const CardHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
`;

export const CardTitle = styled.h1`
  text-align: center;
  line-height: 1.5;
  color: #104467;
`;

export const CategoryTitle = styled.h2`
  text-align: center;
  color: #104467;
  font-size: 1.25rem;
`;

export const FileButton = styled.button`
  background: white;
  border: 1px solid #104467;
  border-radius: 3px;
  cursor: pointer;
  padding: 10px;
  margin: 3px;
  color: #104467;

  &:hover {
    background: rgba(0, 0, 0, 0.1);
  }
`;

export const TermsText = styled.span`
  margin-top: 20px;
  color: #104467;
  text-align: center;
`;

export const LinkText = styled.a`
  color: #1e88e5;
  cursor: pointer;

  &:hover {
    color: #1565c0;
  }
`;

export const CustomButton = styled.button`
  background: #104467;
  border: none;
  border-radius: 3px;
  cursor: pointer;
  padding: 10px;
  margin: 3px;
  margin-top: 20px;
  color: white;

  &:hover {
    background: rgb(9, 41, 61);
  }
`;

export const DisabledCustomButton = styled.button`
  background: #eeeeee;
  border: none;
  border-radius: 3px;
  padding: 10px;
  margin: 3px;
  margin-top: 20px;
  color: #666666;
`;

export const ForgetPasswordContainer = styled.div`
  margin-bottom: 20px;
  display: flex;
  width: 100%;
`;

export const ForgetPassword = styled.span`
  font-size: 0.75rem;
  cursor: pointer;
`;
